import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import App from './components/App';
import { expireSessionIfStale } from './shared/auth/session';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// Sessão expirada: vai para /login sem montar rotas lazy (evita abort de chunk).
if (!expireSessionIfStale()) {
  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);

  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
      {process.env.NODE_ENV !== 'production' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>,
  );
}
